import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getDeedForGoalActions } from './helper';

const TreeGoalActions = ({
    data: propData,
    edit: propEdit,
    nestingLevel: propNestingLevel,
    onAction: propOnAction,
    t
}) => {
    const [state, setState] = useState(() => ({
        ...getDeedForGoalActions(propData),
        nestingLevel: propNestingLevel || 0
    }));

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            ...getDeedForGoalActions(propData)
        }));
    }, [propData]);

    const onDelete = useCallback((event) => {
        const id = event.target.closest('.goal-action-tree__close').getAttribute('data-id');
        propOnAction && propOnAction(id);
    }, [propOnAction]);

    const getMainClass = useCallback(() => {
        return classNames({
            'goal-action': true,
            'goal-action_active': propEdit
        });
    }, [propEdit]);

    const getTitleClass = useCallback((isLast) => {
        return classNames({
            'goal-action-tree__title': true,
            'goal-action-tree__title_hover': propEdit && isLast
        });
    }, [propEdit]);

    const renderButtonClose = useCallback((id) => {
        return (
            <span
                className="goal-action-tree__close"
                data-id={id}
                onClick={onDelete}
            >
                <span className="fa fa-trash-o" />
            </span>
        );
    }, [onDelete]);

    const renderTree = useCallback((list = state.list, level = 1) => {
        let nextLevel = level + 1;
        return (
            <ul className="goal-action-tree">
                {Object.keys(list).map((key) => {
                    const item = list[key];
                    const isList = !!item.list;
                    return (
                        <li className="goal-action-tree__item" key={key}>
                            {!isList && propEdit
                                ? renderButtonClose(item.idGoalAction)
                                : null
                            }
                            <div className={getTitleClass(!isList)}>{`(${key}) ${item.title}`}</div>
                            {isList && state.nestingLevel !== level
                                ? renderTree(item.list, nextLevel)
                                : null
                            }
                        </li>
                    )
                })}
            </ul>
        );
    }, [state.list, state.nestingLevel, propEdit, renderButtonClose, getTitleClass]);

    return (
        <div className={getMainClass()}>
            {renderTree()}
            {state.unavailable.length
                ? propEdit
                    ? (
                        <div className="goal-action-tree goal-action-tree_unavailable">
                            <div className={getTitleClass()}>Недоступны:</div>
                            <ul className="goal-action-tree">
                                {state.unavailable.map((id) => (
                                    <li className="goal-action-tree__item" key={id}>
                                        {renderButtonClose(id)}
                                        <div className={getTitleClass(true)}>{id}</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                      )
                    : <div className="goal-action-tree goal-action-tree_unavailable">Недоступны: {state.unavailable.join(', ')}</div>
                : null
            }
        </div>
    );
};

TreeGoalActions.propTypes = {
    data: PropTypes.array,
    edit: PropTypes.bool,
    nestingLevel: PropTypes.number,
    onAction: PropTypes.func,
    t: PropTypes.object
};

TreeGoalActions.defaultProps = {
    data: [],
    edit: false,
    nestingLevel: 0,
    onAction: () => {}
};

export default withTranslation(TreeGoalActions);
